import { MenuItem, Select, SelectChangeEvent } from '@mui/material';
import { useCallback } from 'react';
import { SettingsInputProps } from './SettingsInputProps';

export const SelectSettingsInput = (props: SettingsInputProps) => {
  const value = props.numeric
    ? props.value?.intValue?.toString()
    : props.value?.stringValue;
  const onChange = useCallback(
    (e: SelectChangeEvent) => {
      props.onChange(
        props.numeric
          ? { intValue: Number(e.target.value) }
          : { stringValue: e.target.value },
      );
    },
    [props.numeric, props.onChange],
  );

  return (
    <Select fullWidth size='small' value={value ?? ''} onChange={onChange}>
      {(props.options ?? []).map((option) => (
        <MenuItem key={option.value} value={String(option.value)}>
          {option.label}
        </MenuItem>
      ))}
    </Select>
  );
};
